import "./App.css";
import {
  Navigate,
  Outlet,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import Login from "./Page/Login";
import Page1 from "./Page/Page1";
import History from "./Page/History";
import Report from "./Page/Report";
import Dashboard from "./Page/Dashboard";
import { ToastContainer } from "react-toastify";
import { useEffect } from "react";
import ProtectedRoute from "./Components/ProtectedRoute";
import LandingPage from "./Page/LandingPage";
import Aboutpage from "./Page/Aboutus";
import LandingHeader from "./Components/LandingPage/Header";
import LandingFooter from "./Components/LandingPage/Footer";
import AboutPage from "./Page/Aboutus";
import Contactus from "./Page/contactus";
import ReferenceStructuring from "./Page/Reference";

function App() {
  const navigate = useNavigate();

  const location = useLocation();

  // Extract the token from the URL search parameters
  const searchParams = new URLSearchParams(location.search);
  const token = searchParams.get("token");

  if (token) {
    localStorage.setItem("token", token);
  }

  function HeaderLayout() {
    return (
      <>
        <LandingHeader />
        <Outlet />
        <LandingFooter />
      </>
    );
  }

  return (
    <div className="App">
      <ToastContainer
        position="top-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      <Routes>
        <Route path="/" element={<Navigate to="/home" />} />
        <Route element={<HeaderLayout />}>
          <Route path="/home" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<Contactus />} />
        </Route>

        <Route path="/login/:state" element={<Login />}></Route>
        <Route
          path="/uploadfiles"
          element={
            <ProtectedRoute>
              <Page1 />
            </ProtectedRoute>
          }
        />
           <Route
          path="/reference_structure"
          element={
              <ReferenceStructuring />
          }
        />
        <Route
          path="/filehistory"
          element={
            <ProtectedRoute>
              <History />
            </ProtectedRoute>
          }
        />
        <Route
          path="/report/:id"
          element={
            <ProtectedRoute>
              <Report />
            </ProtectedRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </div>
  );
}

export default App;
